<template>
  <a-modal
    :width="width"
    :visible="true"
    :maskClosable="false"
    cancelText="取消"
    okText="确定"
    centered
    :wrapClassName="'custom-form-modal'"
    @cancel="
      () => {
        // resetFields();
        $emit('cancel');
      }
    "
  >
    <page-model-2
      :modalType="obj.modalType"
      :activeKey="'123'"
      :search="obj.search"
      :title="obj.title"
    />
    <template #footer>
      <a-button
        type="primary"
        @click="
          () => {
            $emit('cancel');
          }
        "
      >
        关闭
      </a-button>
    </template>
    <template #title>
      <div ref="modalTitleRef" style="width: 100%; cursor: move">{{ obj.title }}</div>
    </template>
    <template #modalRender="{ originVNode }">
      <div :style="transformStyle">
        <component :is="originVNode" />
      </div>
    </template>
  </a-modal>
</template>

<script lang="ts">
import { useForm } from 'ant-design-vue/es/form';
import { computed, defineComponent, reactive, CSSProperties, ref, watch, watchEffect } from 'vue';
import { useDraggable } from '@vueuse/core';
const permissionActions = ['add', 'delete', 'update', 'query', 'import', 'export'];
import PageModel2 from '@/components/page-model2/index.vue';
export default defineComponent({
  name: 'TablePageModal2',
  props: {
    obj: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    console.log('obj', props.obj);
    const width = '1200px';
    const modalTitleRef: any = ref(null);
    const { x, y, isDragging } = useDraggable(modalTitleRef);
    const startX = ref<number>(0);
    const startY = ref<number>(0);
    const startedDrag = ref(false);
    const transformX = ref(0);
    const transformY = ref(0);
    const preTransformX = ref(0);
    const preTransformY = ref(0);
    const dragRect = ref({ left: 0, right: 0, top: 0, bottom: 0 });
    watch([x, y], () => {
      if (!startedDrag.value) {
        startX.value = x.value;
        startY.value = y.value;
        const bodyRect = document.body.getBoundingClientRect();
        const titleRect = modalTitleRef.value.getBoundingClientRect();
        dragRect.value.right = bodyRect.width - titleRect.width;
        dragRect.value.bottom = bodyRect.height - titleRect.height;
        preTransformX.value = transformX.value;
        preTransformY.value = transformY.value;
      }
      startedDrag.value = true;
    });
    watch(isDragging, () => {
      if (!isDragging) {
        startedDrag.value = false;
      }
    });
    watchEffect(() => {
      if (startedDrag.value) {
        transformX.value =
          preTransformX.value +
          Math.min(Math.max(dragRect.value.left, x.value), dragRect.value.right) -
          startX.value;
        transformY.value =
          preTransformY.value +
          Math.min(Math.max(dragRect.value.top, y.value), dragRect.value.bottom) -
          startY.value;
      }
    });
    const transformStyle = computed<CSSProperties>(() => {
      return {
        transform: `translate(${transformX.value}px, ${transformY.value}px)`,
      };
    });

    return {
      props,
      width,
      modalTitleRef,
      transformStyle,
      permissionActions,
    };
  },
  components: {
    PageModel2,
  },
});
</script>
<style>
.custom-form-modal .ant-modal-body {
  max-height: 600px;
  overflow: auto;
}
/*.ant-form-item {*/
/*  margin-bottom: 6px;*/
/*}*/
.custom-form-modal1 .ant-modal-body {
  max-height: 670px;
  overflow: auto;
}
</style>
